import { FlexColumn, FlexRow, FullContainer, StyledButton, useLoading } from '@gorila-shared-ui/components';
import { areEqual } from 'react-window';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { updateLiveStatusSettings } from '../../../services/settingsService';
import { apiParamsState } from '../../../storage/app';
import {
  editingLiveStatusSettingsState,
  liveStatusSettingsState,
  updateLiveStatusSettingsState,
} from '../../../storage/settings';
import LiveStatusSettingsProvider from '../../providers/LiveStatusSettingsProvider';
import { LiveStatusSettingsList } from './LiveStatusSettingsList';

export function LiveStatusSettingsTab() {
  const { css, classes, theme } = useStyles();
  const { loading, startLoading, stopLoading } = useLoading();
  const apiParams = useRecoilValue(apiParamsState);
  const liveStatusSettings = useRecoilValue(liveStatusSettingsState);
  const editingLiveStatusSettings = useRecoilValue(editingLiveStatusSettingsState);
  const resetEditingLiveStatusSettings = useResetRecoilState(editingLiveStatusSettingsState);
  const setUpdateLiveStatusSettings = useSetRecoilState(updateLiveStatusSettingsState);
  const { showFailFeedback } = useFeedback();

  const onSaveLiveStatusSettings = async () => {
    if (!apiParams || !editingLiveStatusSettings) return;
    startLoading();
    const { error } = await updateLiveStatusSettings(
      apiParams.clientId,
      apiParams.subClientId,
      editingLiveStatusSettings
    );
    if (!error) {
      setUpdateLiveStatusSettings('update');
    } else {
      showFailFeedback(error || 'Ocurrió un error al editar, inténtalo más tarde.');
    }
    stopLoading();
  };

  const hasUpdates = !areEqual(liveStatusSettings || {}, editingLiveStatusSettings || {});

  return (
    <FullContainer verticalFlex>
      <FlexColumn
        classNames={css({
          flex: 1,
          overflow: 'hidden',
          [theme.mediaQuery.large]: {
            maxWidth: '60%',
          },
          [theme.mediaQuery.extraLarge]: {
            maxWidth: '50%',
          },
        })}
      >
        <LiveStatusSettingsProvider />
        <LiveStatusSettingsList />
        <FlexRow classNames={classes.centeredEnd}>
          <StyledButton
            kind="tertiary"
            onClick={resetEditingLiveStatusSettings}
            disabled={!hasUpdates}
          >
            Restaurar
          </StyledButton>
          <StyledButton
            onClick={onSaveLiveStatusSettings}
            isLoading={loading}
            disabled={!hasUpdates}
          >
            Guardar
          </StyledButton>
        </FlexRow>
      </FlexColumn>
    </FullContainer>
  );
}
